import { CartItemType, removeFromCart } from "@/store/cart.slice";
import { AppConfig } from "@/utils/AppConfig";
import { GoTrash } from "react-icons/go";
import { useDispatch } from "react-redux";
import OptionsAndAddonAccordion from "./OptionsAndAddonAccordion";
import { useTranslation } from "react-i18next";
import { formatMoney } from "@/utils/helpers";
import { removeFromTableCart } from "@/store/tableCartSlice";

function CashierCartItem({ item, isTable }: { item: CartItemType; isTable?: boolean }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleDeleteItem = () => {
    if (isTable) {
      dispatch(removeFromTableCart(item));
    } else {

      dispatch(removeFromCart(item));
    }
  };

  return (
    <div className="flex flex-col items-center border-b border-gray-300 p-2">
      <div className="flex w-full items-center justify-between gap-y-3">
        {/* quantity, image, name  */}
        <div className="flex items-center gap-x-3">
          <p className="flex items-center gap-1 whitespace-nowrap text-lg font-bold">
            x {item.quantity}
          </p>

          <img src={item.image} alt="item" className="h-12 w-12 rounded-md" />

          <p className="max-w-[50%]">{t(item.nameEN, item.nameAR)}</p>
        </div>

        {/* price, delete  */}
        <div className="flex items-center gap-x-3">
          <p
            dir="rtl"
            className="flex items-center gap-1 whitespace-nowrap text-base font-bold"
          >
            <span>{formatMoney(item.price)}</span>
            <span>{AppConfig.currency.icon()}</span>
          </p>

          <button onClick={handleDeleteItem} className="text-red-500">
            <GoTrash size={20} className="text-gray-400 hover:text-red-500" />
          </button>
        </div>
      </div>

      <OptionsAndAddonAccordion
        addonsNames={item.addonsNames || []}
        optionsNames={item.optionsNames || []}
      />
    </div>
  );
}

export default CashierCartItem;
